import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { environment as env } from '@environments/environment';
import { map } from 'rxjs';
import { OneTimePricingPlan } from '@models/pricing-plans/one-time-pricing-plan.model';

@Injectable()
export class PricingPlanService {
  constructor(private api: ApiService) {}

  getOneTimePricingPlans() {
    return this.api
      .get<OneTimePricingPlan[]>(`${env.api}/pricing-plans/one-time`)
      .pipe(map(this.mapOneTimePricingPlans));
  }

  private mapOneTimePricingPlans(res: OneTimePricingPlan[]) {
    return res?.map((it) => new OneTimePricingPlan(it));
  }
}
